import { Box, Typography } from "@mui/material";
import Iconify from "../../components/iconify/Iconify";

const EmptyAddonState = () => {
  return (
    <Box
      sx={{
        textAlign: "center",
        py: 5,
        px: 4,
        border: "1px dashed #ccc",
        borderRadius: 2,
        backgroundColor: "#f9f9f9",
      }}
    >
      <Iconify icon="mdi:tag-plus-outline" width={50} height={50} />
      <Typography variant="h6" gutterBottom>
        No Addons Added Yet
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Addons help you customize your items. Select from the list and click
        "Add" to include them.
      </Typography>
    </Box>
  );
};

export default EmptyAddonState;
